// eslint-disable-next-line
const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

// Do not delete EMAIL_REGEX_QUIZ it's for the tech career path quiz input pattern validation
export const EMAIL_REGEX_QUIZ =
  /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,9}$/

export function validateEmail(email, quiz = false) {
  if (quiz) {
    return EMAIL_REGEX_QUIZ.test(String(email).toLowerCase())
  } else return EMAIL_REGEX.test(String(email).toLowerCase())
}
